// Generated by sync-language-release.cjs.
import messages_de from './de.json';
import messages_en from './en.json';
import messages_nl from './nl.json';
import messages_fr from './fr.json';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import release from './language-release.json';
export const defaultLanguage = release.manager_ui.default_language;
export const fallbackLanguage = release.manager_ui.fallback_language;
export const languages = Object.entries(release.languages)
  .filter(([code]) => release.manager_ui.languages.includes(code))
  .map(([code, item]) => ({ code, name: item.native_name, locale: item.locale }));
export const messages = { de: messages_de, en: messages_en, nl: messages_nl, fr: messages_fr };
